<template>
    <div class="operate-bar-wrap">
        <RoundButton @btnClick="addClick" class="add-btn" :text="addVideo" v-show="hasShowBtn" v-if="!refercence" />
        <LangSelect value="all" class="lang-select" @change="langChange" :requireAll="true"></LangSelect>
        <Select initValue="" :options="usageStatusOptions" @menuClick="usageChange" />
        <Select :initValue="getInitData" :options="sourceData" :class="{ 'source-select': hasShowBtn }" @menuClick="sourceChange" />
        <Select initValue="updateTime" :options="sequenceOptions" class="sequence-select" @menuClick="sequenceChange" />
        <Search :placeholder="placeholder" class="strategy-search" @searchChange="searchChange" @inputChange="searchChange"></Search>
        <RoundButton v-show="tagId" @btnClick="showConfigModal" class="classify-config-btn" :text="classifyConfig" />
    </div>
</template>

<script>
import RoundButton from "@/views/zhiji/bComponents/buttons/RoundButton";
import Select from "@/views/zhiji/bComponents/inputs/Select";
import Search from "@/views/zhiji/bComponents/inputs/Search";
import VideoEditModel from "./VideoEditModel";
import LangSelect from "@/components/langSelect";
import ClassifyNameConfig from "@/views/zhiji/components/materialLibrary/ClassifyNameConfig";
import { sequenceOptions, usageStatusOptions } from "@/views/zhiji/components/materialLibrary/materialLibraryConfig.js";
import { debounce, strTrim } from "@/views/zhiji/js/common/util.js";

export default {
    name: "VideoTopOperateBar",
    props: ["sourceData", "showAddBtn", "refercence", "tagId"],
    components: {
        RoundButton,
        Select,
        Search,
        LangSelect
    },
    computed: {
        sequenceOptions() {
            return sequenceOptions();
        },
        usageStatusOptions() {
            return usageStatusOptions();
        },
        addVideo() {
            return this.$t("zhiji.materialLibrary.addVideoBtn");
        },
        placeholder() {
            return this.$t("zhiji.common.inputHolderLabel");
        },
        getInitData() {
            return this.sourceData && this.sourceData[0].value;
        },
        hasShowBtn() {
            return this.showAddBtn ? false : true;
        },
        classifyConfig() {
            return this.$t("zhiji.materialLibrary.classifyConfig");
        }
    },
    mounted() {
        this.searchHanlder = debounce(data => {
            let searchField = data[0];
            this.searchVideoList(searchField);
        }, 500);
    },
    methods: {
        addClick() {
            this.$store.dispatch("zhiji/showModal", {
                type: VideoEditModel,
                data: {
                    type: "add",
                    videoData: {}
                }
            });
        },
        showConfigModal() {
            // 分类名配置弹框
            this.tagId &&
                this.$store.dispatch("zhiji/showModal", {
                    type: ClassifyNameConfig,
                    data: {
                        tagId: this.tagId
                    }
                });
        },
        usageChange(data) {
            this.$store.dispatch("zhiji/queryVideoList", {
                usageStatus: data.value,
                page: 1,
            });
            this.$emit('switchClick', data);
        },
        sourceChange(data) {
            this.$store.dispatch("zhiji/queryVideoList", {
                source: data.value,
                page: 1
            });
            this.$emit("switchClick", data);
        },
        sequenceChange(data) {
            this.$store.dispatch("zhiji/queryVideoList", {
                sequence: data.value,
                page: 1
            });
            this.$emit("switchClick", data);
        },
        searchChange(data) {
            this.searchHanlder(data);
        },
        searchVideoList(data) {
            this.$store.dispatch("zhiji/queryVideoList", {
                videoName: strTrim(data.value),
                page: 1
            });
            this.$emit("switchClick", data);
        },
        langChange(data) {
            this.$store.dispatch("zhiji/queryVideoList", {
                lang: data,
                page: 1
            });
            this.$emit("switchClick");
        }
    }
};
</script>

<style scoped lang="less">
.operate-bar-wrap {
    padding: 10px 24px;
    border-bottom: 1px solid #d8e4f0;
    display: flex;
    align-items: center;
    background-color: #fff;
    .add-btn {
        margin-right: 45px;
    }
    .strategy-search {
        width: 318px;
        padding: 0;
        overflow: hidden;
        height: 32px;
    }
    .classify-config-btn {
        border: solid 1px #d8e4f0;
        color: #41475e;
        background: #fff;
        box-shadow: none;
        line-height: 30px;
        border-radius: 4px;
        margin-left: 10px;
        padding: 0 24px;
        &:hover {
            color: #2ec2ff;
        }
    }
    .lang-select {
        width: 120px;
        margin-right: 8px;
    }
}
</style>
